import axios from "axios";
import { IASSESS_BASE_URL } from "../../../constants/urls";

const axiosInstance = axios.create({
  baseURL: IASSESS_BASE_URL
});

export default axiosInstance;